import { ReactComponent as CalendarIcon } from '../../../../assets/icons/timeline/calendarIcon.svg';
import { orderBy, map, filter, includes, findIndex } from 'lodash';
import useStores from '../../../../hooks/useStores';
import { IMeeting, meetingStatus } from '../../../Meetings/store';
import getMeetingTitle from '../../../../utils/getMeetingTitle';

export default function useMeetingEvent(patientUuid: string) {
  const { meetingsStore } = useStores();
  const meetings: IMeeting[] = meetingsStore.meetings[patientUuid];
  const orderedMeetings = orderBy(meetings, 'meetingTime', 'asc');
  const validMeetings = filter(
    orderedMeetings,
    ({ status }) =>
      status === meetingStatus.DONE || status === meetingStatus.SCHEDULED
  );
  return map(orderedMeetings, (x) => {
    const index = findIndex(validMeetings, ['uuid', x.uuid]);
    return {
      name: includes(
        [meetingStatus['NO SHOW'], meetingStatus.CANCELED],
        x.status
      )
        ? 'Meeting canceled'
        : getMeetingTitle(index),
      date: x.meetingTime,
      icon: CalendarIcon,
      description: x?.note,
    };
  });
}
